var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortfolio1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.23,
    height: 29.206,
    viewBox: "0 0 33.23 29.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "portfolio_1_",
    "data-name": "portfolio (1)",
    transform: "translate(0 -31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(0 31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M30.31,34.894H24.456L23.38,31.666A.974.974,0,0,0,22.457,31H10.774a.973.973,0,0,0-.924.666L8.774,34.894H2.921A2.924,2.924,0,0,0,0,37.815v5.841a.974.974,0,0,0,.54.872l.433.216V57.286a2.924,2.924,0,0,0,2.921,2.921H29.336a2.924,2.924,0,0,0,2.921-2.921V44.743l.433-.216a.974.974,0,0,0,.54-.872V37.815A2.924,2.924,0,0,0,30.31,34.894ZM11.476,32.947H21.755l.649,1.947H10.827ZM30.31,57.286a.975.975,0,0,1-.974.974H3.894a.975.975,0,0,1-.974-.974V45.712l8.9,4.424a2.925,2.925,0,0,0,2.849,2.282h3.894a2.925,2.925,0,0,0,2.849-2.282l8.9-4.424ZM13.695,49.5a.975.975,0,0,1,.974-.974h3.894a.974.974,0,1,1,0,1.947H14.668A.975.975,0,0,1,13.695,49.5Zm17.589-6.444L21.128,48.1a2.923,2.923,0,0,0-2.565-1.526H14.668A2.923,2.923,0,0,0,12.1,48.1L1.947,43.053V37.815a.975.975,0,0,1,.974-.974H30.31a.975.975,0,0,1,.974.974Z",
    transform: "translate(0 -31)",
    fill: "#329bc9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio1);
export default __webpack_public_path__ + "static/media/portfolio (1).832b09f6c4cc8cb9264c7eca216fe3bc.svg";
export { ForwardRef as ReactComponent };